export const CISCO_SDA_CONSTANTS = {
  Hero_desc: [
    "Cloudmylab Offers a Fully Built Cisco Software Defined Access On-demand Lab Infrastructure with real hardware, latest software, as well as the licensing.",
    "Cisco Software Defined Access architecture is designed towards meeting the IT transformation goals around simplicity, operational effectiveness, and security.",
    "This architecture provides an open, software-driven platform that integrates critical innovations in networking software, such as virtualization, automation, analytics, cloud, into a unified architecture for wired, wireless, and remote access.",
  ],
  Hero_points: [
    "Our Labs has been designed with a fairly open topology that can be purposed for any POC or Certification Labs.",
  ],
};

export const CISCO_SDA_FAQ_LIST = [
  {
    title: "Do you sell/Provide workbooks with  SDA LABS",
    content:
      "No, but we do provide detailed  Sample Labs/Configuration Examples and you can use our labs with any vendor labs.  You can check the documentation Section, we partner with Industry’s top consultants to build those samples.",
  },
  {
    title: "Do you offer  Training for the Learning Labs ?",
    content:
      "Cloudmylab is an Infrastructure Provider and we do not offer any  Virtual or In-person Training, However, we will be happy to connect you with our awesome training Partners Patriot Solutions and Training world 360.",
  },
  {
    title: "Are these Labs locked to a certain configurations only ?",
    content:
      "The only thing fixed in the setup is IP schema and Cluster Interface.  You can feel free to change things around, upload/Create your own virtual machines and tie it back to the Lab.",
  },
  {
    title: "What does 3 Days access Mean ?",
    content:
      "3 Day Access Means that you will have access to the Lab for 3 Calendar Days 24X3",
  },
  {
    title:
      "I am stuck and need help configuring SDA or need a consult on an integration, can you guys Help ?",
    content:
      "Yes, we can engage our Professional Services Team.  As a general rule, our Level 1 support team is not equipped to troubleshoot specific scenarios built by you.",
  },
  {
    title: "So what does your Level 1 Support do ?",
    content:
      "Our Level 1 Support will ensure that your Lab infrastructure and underlying automation is in perfect condition, so you can do what you like.",
  },
  {
    title: "What can I accomplish on your Lab Infrastructure with SDA ?",
    content:
      "You could use our Sample Labs to get started and you can build on top of it. All the Features are supported as listed out the software release of the version.",
  },
  {
    title: "What if I need additional Hardware or software ?",
    content:
      "The Learning Labs are general purpose labs and you can attach anything virtual by using the UCS in the lab environment, for additional Hardware , please utilize our POC-AS-A-Service or LAB-As-A Service.",
  },
];

export const CISCO_SDA_HW_LIST = [
  "Cisco SDA Version 1.3.3.8",
  "1 X Catalyst C9300 ( Border|Control|WLC)",
  "1 X Catalyst C9300/C9200/3800/3600 (Edge)",
  "1 X Cisco DNA Appliance",
  "1 X Cisco 1800/3700/3800 Access Point",
  "1 X Jumpbox",
  "Virtual Machines",
  "1 X Cisco ISE",
  "1 X DNS /AD Server",
  "1 X Wired PC ( Windows 10)",
  "1 X Wireless PC ( Windows 10)",
];

export const CISCO_SDA_PRICING_CARD_LIST = [
  {
    days: 3,
    options: [
      "Version 2.3.7.4",
      "1 X C9300-A (Border)",
      "1 X C9300-A/3800 (Leaf)",
      "1 X CSR1000v (Border)",
      "1 X DNA2 Appliance",
      "1 X 3700/1800 Access Point",
      "1 X Cisco ISE",
      "1 X Jump Box",
    ],
  },
  {
    days: 30,
    options: [
      "Version 2.3.7.4",
      "1 X C9300-A (Border)",
      "1 X C9300-A/3800 (Leaf)",
      "1 X CSR1000v (Border)",
      "1 X DNA2 Appliance",
      "1 X 3700/1800 Access Point",
      "1 X Cisco ISE",
      "1 X Jump Box",
    ],
  },
];
